import apiAxios from '@/services/axiosConfig';

async function cancelDeletion(uuid: string): Promise<void> {
  await apiAxios.post(`/api/v1/mt/connections/${uuid}/cancel-deletion`);
}

export default cancelDeletion;
